import dynamic from "next/dynamic";
import { GalleryImageObject } from "../../utils/utils.ts";
import { ImageElementRef } from "@/components/Galleries/components/GalleryImageElement/ImageElement/ImageElement.tsx";

const ImageElement = dynamic(
  () =>
    import(
      /* webpackChunkName: "GalleryImageElement" */
      "./ImageElement/ImageElement.tsx"
    ).then((mod) => mod.ImageElement),
  { ssr: false },
);

type ZoomableImageProps = {
  mediaItem: GalleryImageObject;
  dataTestId?: string;
  className?: string;
  loading?: "eager" | "lazy";
  isSelected: boolean;
  index?: number;
  ref?: React.RefObject<ImageElementRef>;
};

export function ZoomableImage({ mediaItem, isSelected }: ZoomableImageProps) {
  return (
    <ImageElement
      image={mediaItem}
      key={mediaItem.imageUrl}
      isSelectedIndex={isSelected}
    />
  );
}
